import { Form, Input, Select } from 'antd';
import { Rule } from 'antd/lib/form';
import { useCallback, useEffect, useState } from 'react';
import metaApi from './meta-service';

const { Option } = Select;

interface Props {
  title: string;
  name: string;
  placeholder?: string;
  countryCodeRules?: Rule[];
  phoneNumberRules?: Rule[];
  defaultCode?: string | number;
  onchange?: (code: string) => void;
  disabled?: boolean;
  defaultValueNum?: string;
  editSignUp?: any;
  dataInfo?: any;
}

interface ICountry {
  calling_code: string;
  flag: string;
  id: number;
  language: string;
  lookupCode: string;
  lookupCodeId: string;
  priority: string;
  value: string;
}

const CountryPhoneInput: React.FC<Props> = ({
  title,
  name,
  countryCodeRules,
  phoneNumberRules,
  placeholder = '',
  defaultCode = '',
  onchange,
  disabled,
  defaultValueNum,
  editSignUp,
  dataInfo
}) => {
  const [countryCodes, setCountryCodes] = useState<ICountry[]>([]);
  const [defaultValue, setDefaultValue] = useState<number>();

  const _getMetaData = useCallback(async () => {
    const responseData = await metaApi['getMetaData']();
    const reOrderData = [...responseData?.data.country_code];

    reOrderData.push(reOrderData.shift());
    const countryDefault = reOrderData.filter(
      (x) => x.calling_code === '1' && x.priority === '5'
    )[0]?.id;
    if (defaultCode) {
      const selected = reOrderData.find(
        (item) => item.lookupCodeId === defaultCode
      );
      selected ? setDefaultValue(selected.id) : setDefaultValue(countryDefault);
    } else {
      setDefaultValue(countryDefault);
    }
    // }
    setCountryCodes(reOrderData);
  }, [defaultCode]);

  const _renderCountryFlag = useCallback(() => {
    return countryCodes.map((country) => {
      return (
        <Option key={country.id} value={country.id}>
          <img src={country?.flag} alt="" width={24} height={24} />
          <span className="ml-4 calling-code">+{country.calling_code}</span>
        </Option>
      );
    });
  }, [countryCodes]);

  const _handleOnchange = useCallback(
    (id: number) => {
      const selected = countryCodes.find((item) => item.id === id);
      setDefaultValue(id);
      // onchange && onchange(selected!.calling_code);   test
      onchange && onchange(selected!.lookupCodeId);
    },
    [countryCodes, onchange]
  );

  useEffect(() => {
    _getMetaData();
  }, [_getMetaData]);

  return (
    <Form.Item label={title}>
      <Input.Group style={{ display: 'flex', flexDirection: 'row' }}>
        <Form.Item noStyle rules={countryCodeRules}>
          <Select
            className="flag-select"
            onChange={(value) => _handleOnchange(value)}
            value={defaultValue}
            disabled={disabled}
          >
            {_renderCountryFlag()}
          </Select>
        </Form.Item>

        <Form.Item name={name} noStyle rules={phoneNumberRules}>
          <Input
            type="number"
            className="border-input"
            placeholder={placeholder}
            disabled={disabled}
          />
        </Form.Item>
      </Input.Group>
    </Form.Item>
  );
};

export default CountryPhoneInput;
